import Vue from 'vue';
import App from '@/App';

import router from '@/router';

Vue.config.productionTip = false;

// -----------------
// Directives
// -----------------

// Mouse Parallax
import mouseParallax from '@/directives/mouse-parallax';
Vue.directive('mouseParallax', mouseParallax);
// Scroll Into View
import scrollIntoView from '@/directives/scroll-into-view';
Vue.directive('scrollIntoView', scrollIntoView);
// Parallax Zone
import parallaxZone from '@/directives/parallax-zone';
Vue.directive('parallaxZone', parallaxZone);

// -----------------
// Components
// -----------------

// App Button
import AppButton from '@/components/AppButton';
Vue.component('AppButton', AppButton);
// Popup Text
import PopupText from './components/PopupText';
Vue.component('PopupText', PopupText);
// Parallax Image
import ParallaxImage from './components/ParallaxImage';
Vue.component('ParallaxImage', ParallaxImage);
// FontAwesomeIcon
import FA from '@/components/FA';
Vue.component('FA', FA);
// Footer
import Footer from '@/components/Footer';
Vue.component('Footer', Footer);
// Navbar
import Navbar from '@/components/Navbar';
Vue.component('Navbar', Navbar);
// Section Divider
import SectionDivider from '@/components/SectionDivider';
Vue.component('SectionDivider', SectionDivider);
// Section Title Card
import SectionTitleCard from '@/components/SectionTitleCard';
Vue.component('SectionTitleCard', SectionTitleCard);

new Vue({
  el: '#app',
  data: {
    isMobile: false,
    isMobileDevice: false,
    scrollDisabled: false,
    shopLink: 'https://zephyr-sim.com/checkout?product=kidswithdrones'
  },
  methods: {
    openShop() {
      window.open(this.shopLink);
    }
  },
  watch: {
    scrollDisabled(val) {
      if (val) {
        $('html').addClass('no-scroll');
      } else {
        $('html').removeClass('no-scroll');
      }
    }
  },
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js